import {
  createStartAction,
  createSuccessAction,
} from '../../redux-util/async-helpers';
import {
  INCREASE_ZOOM,
  DECREASE_ZOOM,
  SET_ZOOM_SCALE,
} from '../jigsaw-methods';
import { createReducer } from '../../redux-util/general-helpers';
import { withDestroyViewerReset } from '../../reset-reducer-helpers';

const increaseSuccess = createSuccessAction(INCREASE_ZOOM).type;
const decreaseSuccess = createSuccessAction(DECREASE_ZOOM).type;
const setStart = createStartAction(SET_ZOOM_SCALE).type;

const base = {
  [increaseSuccess]: (state, action) => action.data.zoomScale,
  [decreaseSuccess]: (state, action) => action.data.zoomScale,
  // This needs to be the start even to sync up nicely with the scaling factor in the UI
  [setStart]: (state, action) => action.data[0],
};

export default withDestroyViewerReset(createReducer(1, base));
